import styled from 'particles/themes/styled'

export const PaymentListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[400]};

    .payment-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, 270px);
        gap: ${({ theme }) => theme.spacing[300]};
    }
`
